"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cardActionsTypes = void 0;

var _propTypes = require("prop-types");

var cardActionsTypes = {
  header: (0, _propTypes.shape)({
    title: _propTypes.string,
    subtitle: _propTypes.string,
    menu: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      name: _propTypes.string,
      onPress: _propTypes.func
    }))
  }),
  footer: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    name: _propTypes.string,
    onPress: _propTypes.func
  }))
};
exports.cardActionsTypes = cardActionsTypes;